import { Dispatch, useEffect, useState } from 'react';

import { getCancellationReasons } from '../api/services/CancelRide';

interface IUseCancelReason {
  cancelReasons: CancelReason[];
  setRideScope: Dispatch<React.SetStateAction<string>>;
}

export const useCancelReason = (scope: string): IUseCancelReason => {
  const [rideScope, setRideScope] = useState<string>(scope);
  const [cancelReasons, setCancelReasons] = useState<CancelReason[]>([]);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchCancelReasons() {
      const response = await getCancellationReasons(rideScope, abortController.signal);

      if (response?.type === 'success' && response.data.reasons?.length > 0) {
        setCancelReasons(response.data.reasons);
      }
    }
    fetchCancelReasons();

    return () => abortController.abort();
  }, [rideScope]);

  return {
    cancelReasons,
    setRideScope,
  };
};
